import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_RESET,
} from "./actionTypes";

const initialState = {
  forgetSuccess: false,
  forgetError: false,
  loading: false,
};

const ForgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      // Keep forgetSuccess, so resending stays on the "check your email" view
      state = {
        ...state,
        forgetError: false,
        loading: true,
      };
      break;
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccess: true,
        loading: false,
      };
      break;
    case FORGET_PASSWORD_ERROR:
      state = {
        ...state,
        forgetError: true,
        error: action.payload,
        loading: false,
      };
      break;
    case FORGET_PASSWORD_RESET:
      state = initialState;
      break;
    default:
      state = { ...state };
      break;
  }

  return state;
};

export default ForgetPassword;
